import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import walletSlice from 'store/slices/walletSlice';
import contractSlice from 'store/slices/contractSlice';
import globalSlice from 'store/slices/globalSlice';

const rootReducer = combineReducers({
  wallet: walletSlice.reducer,
  contract: contractSlice.reducer,
  global: globalSlice.reducer,
});

const initialState = {};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    process.env.NODE_ENV === 'production'
      ? getDefaultMiddleware().concat([
          // production에서 사용 할 미들웨어를 여기에 추가
        ])
      : getDefaultMiddleware({
          //   serializableCheck: false,
        }).concat([logger]),
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState: initialState,
  enhancers: (defaultEnhancers) => [...defaultEnhancers],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export default store;
